// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__1G_S7","wrapper-nopadding":"wrapper-nopadding__3fl5d","loading":"loading__11S9M","error":"error__36GW8","table-loading":"table-loading__1gwSF","empty-val":"empty-val__2zQWL","panelheader-tools":"panelheader-tools__19KSO","propsPanels":"propsPanels__1-zkI","new":"new__usJrg","marginLm":"marginLm__2DyYc","marginRm":"marginRm__3GZYZ","fullWidth":"fullWidth__3geOO","fullHeight":"fullHeight__3CIfZ","noData":"noData__1xw1s","avatar":"avatar__xp7nU"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Overview/BillingAvatar/styles.scss
// module id = 2310
// module chunks = 1